import { Component, computed, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AcessoService } from '../../../core/acesso/acesso.service';
import { UpperCasePipe } from '@angular/common';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

/** Rotas que exibem o formulário de login — ENTRAR não faz sentido nelas. */
const ROTAS_LOGIN = ['/acesso', '/home'];

@Component({
  selector: 'app-top-navigation',
  standalone: true,
  imports: [UpperCasePipe, NzTypographyModule, NzAvatarModule, NzIconModule, NzToolTipModule, RouterLink, RouterLinkActive, NzButtonModule],
  templateUrl: './top-navigation.component.html',
  styleUrl: './top-navigation.component.scss'
})
export class TopNavigationComponent {
  protected readonly acesso = inject(AcessoService);
  private readonly router = inject(Router);
  title = 'SPO – Sistema de Preços e Orçamentos';

  private readonly urlAtual = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => (e as NavigationEnd).urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  /** Verdadeiro quando o usuário já está numa tela que exibe o formulário de login. */
  protected readonly naTelaDeLogin = computed(() =>
    ROTAS_LOGIN.some(rota => this.urlAtual().startsWith(rota))
  );

  /** Iniciais do primeiro e do último nome, ignorando partículas (de, da, do, dos, das, e). */
  protected iniciais(nome: string | null | undefined): string {
    const partes = (nome ?? '').trim().split(/\s+/).filter(p => p && !PARTICULAS.has(p.toLowerCase()));
    if (partes.length === 0) return '';
    const letras = partes.length === 1 ? partes[0][0] : partes[0][0] + partes[partes.length - 1][0];
    return letras.toUpperCase();
  }
}

const PARTICULAS = new Set(['de', 'da', 'do', 'dos', 'das', 'e']);
